import { StateSchema } from 'app/config/storeConfig/types';
import { TableRowFullInfo } from '../types';

export const getRowFullInfo = (state: StateSchema): Nullable<TableRowFullInfo> => state.tableRowFullInfoModal.rowFullInfo;
